import { useEffect, useState } from 'react';
import { SignIn, useAuth } from '@clerk/react';
import { AuthLayout } from './AuthLayout';

// Runs in the SYSTEM BROWSER (opened by the Electron app at /sign-in?desktop=1).
// Once the user is signed in, mints a single-use Clerk sign-in ticket from the
// server and hands it back to the desktop app via the proclaim:// deep link.
function DesktopAuthHandoff() {
  const { getToken } = useAuth();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        // Mint a one-use handoff code (the desktop redeems it for a session token).
        const res = await fetch('/api/auth/desktop-handoff', {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        const json = await res.json();
        if (cancelled) return;
        if (json.success && json.data?.code) {
          window.location.href = `proclaim://callback?code=${encodeURIComponent(json.data.code)}`;
        } else {
          setFailed(true);
        }
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => { cancelled = true; };
  }, [getToken]);

  return (
    <AuthLayout>
      <div className="w-full max-w-sm rounded-2xl border border-stroke-hi bg-surface-card p-8 text-center">
        {failed ? (
          <p className="text-sm text-rose">
            No se pudo conectar con la aplicación. Cierra esta ventana e intenta de nuevo desde Proclaim.
          </p>
        ) : (
          <p className="text-sm text-ink-muted">
            Sesión iniciada. Regresando a la aplicación Proclaim…
          </p>
        )}
      </div>
    </AuthLayout>
  );
}

// Sign-in page for the desktop handoff flow: shows the branded <SignIn> until the
// user authenticates, then runs the ticket handoff.
export function DesktopSignIn() {
  const { isSignedIn, isLoaded } = useAuth();
  if (isLoaded && isSignedIn) return <DesktopAuthHandoff />;
  return (
    <AuthLayout>
      <SignIn routing="path" path="/sign-in" />
    </AuthLayout>
  );
}
